import { Component } from "@angular/core";

@Component({
  selector: "app-blank-layout",
  templateUrl: "./blank.component.html",
  styleUrls: [],
})
export class BlankComponent {}
